import { getAxios } from "./configure-axios";
import config from "../config/vars";

let axios;

const getAxiosInstance = () => {
  if (!axios) {
    axios = getAxios();
  }
  return axios;
};

export const fetchPrevalidated = async () => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.prevalidated}`);
};

export default {
  fetchPrevalidated
};
